import { notifications } from "@mantine/notifications";

export const showSuccessNotification = (title, message) => {
  notifications.show({
    title,
    message,
    color: "teal",
  });
};

export const showErrorNotification = (error) => {
  notifications.show({
    title: error.title || "Error",
    message: error.userMessage || "An unexpected error occurred.",
    color: "red",
  });
};

export const showInfoNotification = (title, message) => {
  notifications.show({
    title,
    message,
    color: "blue",
  });
};

export const showLoadingNotification = (id, title, message) => {
  notifications.show({
    id,
    title,
    message,
    loading: true,
    autoClose: false,
  });
};

export const updateNotification = (id, props) => {
  notifications.update({
    id,
    ...props,
  });
};
